import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../store/auth';
import breadcrumbsReducer from '../store/breadcrumbs';
import dashboardReducer from '../store/dashboard';
import assetManagementReducer from '../store/asset-management';
import loadingReducer from '../store/asset-loader';
import giftWrapperReducer from '../store/giftwrapper-management';
import giftCategoryReducer from '../store/store-category-management';
import giftMerchnatReducer from '../store/store-merchant-management';
import giftLabelReducer from '../store/store-label-management';
import giftSkuReducer from '../store/sku-management';
import giftSortSkuManagementReducer from '../store/sort-sku-management';
import giftCountryReducer from '../store/country-management';
import flashSaleReducer from '../store/flash-sale-management'
import flashSaleProductReducer from '../store/flash-sale-products-management'
import recommendationReducer from '../store/recommendation-management'
import recommendationProductReducer from '../store/recommendation-products-management'
import bulkPurchaseReducer from '../store/bulk-purchase-management'
import bulkPurchaseVoucherReducer from '../store/bulk-purchase-list-vouchers'


export const store = configureStore({
	reducer: {
		auth: authReducer,
		breadcrumbs: breadcrumbsReducer,
		dashboard: dashboardReducer,
		assetManagement: assetManagementReducer,
		loading: loadingReducer,
		giftWrapperList: giftWrapperReducer,
		giftCategoryList: giftCategoryReducer,
		giftMerchnatList: giftMerchnatReducer,
		giftLabelList: giftLabelReducer,
		skuList: giftSkuReducer,
		giftCountryList: giftCountryReducer,
		giftSortSku: giftSortSkuManagementReducer,
		flashSaleList: flashSaleReducer,
		flashSaleProductList: flashSaleProductReducer,
		recommendationList: recommendationReducer,
		recommendationProductList: recommendationProductReducer,
		bulkPurchaseList: bulkPurchaseReducer,
		bulkPurchaseVouchersList: bulkPurchaseVoucherReducer
	},
});
